import { useMemo } from 'react';
import { reportsApi } from '../api/reports';
import { enqueueReportRun } from '../api/runQueue';
import { normalizeReportQueries } from '../utils/reportQueries';
import { useEffect, useState } from 'react';

function isAbortError(error) {
  return (
    error?.code === 'ERR_CANCELED'
    || error?.name === 'CanceledError'
    || error?.name === 'AbortError'
  );
}

/**
 * Load every report-level SQL query once for the current period.
 */
export function useReportQueries(report, period, enabled = true) {
  const queries = useMemo(
    () => normalizeReportQueries(report?.queries).filter((q) => q.sqlQuery),
    [report?.queries],
  );
  const [resultsById, setResultsById] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!enabled) return undefined;
    if (!queries.length) {
      setResultsById({});
      setLoading(false);
      setError(null);
      return undefined;
    }

    const controller = new AbortController();
    let active = true;
    setLoading(true);
    setError(null);

    enqueueReportRun(
      () => reportsApi.runBatch(queries, period, { signal: controller.signal }),
      { signal: controller.signal },
    )
      .then((res) => {
        if (!active) return;
        setResultsById(res.data?.results || {});
        setLoading(false);
      })
      .catch((e) => {
        if (!active || controller.signal.aborted || isAbortError(e)) return;
        setError(e.response?.data?.error || 'خطا در بارگذاری کوئری‌های گزارش');
        setLoading(false);
      });

    return () => {
      active = false;
      controller.abort();
    };
  }, [enabled, queries, period]);

  return { queries, resultsById, loading, error };
}
